var map = {
	"./de.json": "./src/libs/i18n/locales/de.json",
	"./en.json": "./src/libs/i18n/locales/en.json",
	"./fr.json": "./src/libs/i18n/locales/fr.json",
	"./pt.json": "./src/libs/i18n/locales/pt.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/libs/i18n/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";